<template>
  <div class="liu">
    <!-- 标题 -->
    <mt-header fixed title="任务统计" class="title1">
      <mt-button slot="left" icon="back" @click="onGoBackClick">返回</mt-button>
      <mt-button slot="right" @click="visible.search = true">更多</mt-button>
    </mt-header>
    <div class="scroll-container" :style="customScrollHeight">
      <!-- 提示 -->
      <div class="top-box">
        <div class="between">
          <span>{{ `${emptyStartDate} - ${emptyEndDate}` }}</span>
          <span>
            未达标 <span class="link">{{ myData.sum }}</span> 人
          </span>
        </div>
      </div>
      <!-- 空页 -->
      <div v-if="isShowEmptyData"></div>
      <!-- 列表信息 -->
      <div v-if="isShowListData" class="achi-info tmp-top">
        <div class="info-list" v-for="(item, index) in myData.list" :key="index">
          <div class="list-date">
            <span>{{ item.expiredDate }}</span>
          </div>
          <div class="list-reach" @click="jumpDetail(item.expiredCount, item.expiredDate, myParam.agentFindType, myParam.productAgentId)">
            <span>
              未达标 <span :class="setBlueClass(item.expiredCount)">{{ item.expiredCount }}</span> 人
            </span>
          </div>
        </div>
      </div>
      <!-- 无数据占位图 -->
      <div v-if="isShowNoData">
        <div class="no-data">
          <img src="../assets/member-empty@3x.png" width="60%" />
          <div> {{ `${emptyStartDate}-${emptyEndDate} 暂无相关数据` }}</div>
          <div>点击右上角 <span @click="visible.search = true">更多</span> 查看更多任务统计信息</div>
        </div>
      </div>
    </div>
    <!-- 查询弹出框 -->
    <mt-popup class="agent-popup" v-model="visible.search" position="top" popup-transition="popup-fade">
      <div class="agent-content">
        <!-- 标题 -->
        <mt-header fixed title="筛选" class="title2"></mt-header>
        <!-- 内容 -->
        <div class="popup-content">
          <!-- 状态 -->
          <div class="content-box">
            <div>
              <span>代理商名称或手机号</span>
            </div>
            <div class="box-item no-border">
              <span type="default" class="star" :class="{ 'select-star': myParam.agentFindType === item.value }" v-for="(item, index) in search.agentType.list" :key="index" @click="onAgentTypeClick(item)">
                {{ item.name }}
              </span>
            </div>
            <div v-if="myParam.agentFindType === 2">
              <input type="text" class="name-mobile w56" v-model="search.agent.selected" placeholder="请选择代理商名称或手机号" readonly @click="onAgentNameClick" />
              <img v-show="!search.agent.empty" :src="require('@/assets/clear.png')" alt @click="onAgentNameClearClick" />
            </div>
          </div>
          <div class="content-box">
            <div>
              <span>时间</span>
            </div>
            <div class="no-border">
              <span class="date" @click="onSearchDateClick('startDate')">{{ picker.startDateText }}</span>
              -
              <span class="date" @click="onSearchDateClick('endDate')">{{ picker.endDateText }}</span>
            </div>
          </div>
        </div>
        <!-- 按钮 -->
        <div class="more-button">
          <span class="white" @click="onSearchCancelClick">取消</span>
          <span class="blue" @click="onSearchOkClick">确定</span>
        </div>
      </div>
    </mt-popup>
    <!-- 代理商名称-筛选页面 -->
    <mt-popup class="search-popup" v-model="visible.agent" position="right" :modal="false">
      <mt-header fixed title="选择代理商" class="title2">
        <mt-button slot="left" icon="back" @click="visible.agent = false">返回</mt-button>
      </mt-header>
      <div>
        <form action="" v-on:submit.prevent="">
          <mt-search v-model="search.agent.key" @keyup.enter.native="onAgentSearchEnter" cancel-text="取消" placeholder="输入代理商姓名或手机号" :show="true">
            <div class="result-list">
              <div class="list-row">
                <div class="list-item" v-for="(item, index) in search.agent.list" :key="index" @click="onAgentListItemClick(item)">
                  <span>{{ item.name + " " + item.mobile }}</span>
                </div>
              </div>
            </div>
          </mt-search>
        </form>
      </div>
    </mt-popup>
    <!-- 日期控件 -->
    <mt-datetime-picker ref="datePicker" type="date" :value="picker.selectedDate" :startDate="picker.startDate" :endDate="picker.endDate" year-format="{value} 年" month-format="{value} 月" date-format="{value} 日" @confirm="onDatePickerConfirm"></mt-datetime-picker>
  </div>
</template>

<script>
import { GetUserTaskExpired } from '@/api/reward';
import { GetAgentListBox, DateBase } from '@/api/agent';
import { SucceedHandle2, NotSucceedHandle } from '@/api/handle';
import { CusToast } from '@/utils/CustomToast';
import { formatDate } from '@/utils/utils';
import { Indicator } from 'mint-ui';

export default {
  name: 'TaskCollect',
  data() {
    return {
      // 列表信息
      myData: {
        list: [],
        sum: 0,
        total: -1,
      },
      // 查询参数
      myParam: {
        agentFindType: 3,
        productAgentId: '',
        startDate: '',
        endDate: '',
      },
      // 查询数据
      search: {
        // 代理商状态
        agentType: {
          list: [
            { name: '全部', value: 3 },
            { name: '直销', value: 1 },
            { name: '代理', value: 2 },
          ],
        },
        // 代理商名
        agent: {
          list: [],
          key: '',
          selected: '',
          empty: true,
        },
      },
      // picker时间
      picker: {
        startDateBase: '',
        endDateBase: '',
        startDateText: '',
        endDateText: '',
        startDate: new Date(),
        endDate: new Date(),
        selectedDate: null,
        dateType: '',
      },
      // 显示开关
      visible: {
        search: false,
        agent: false,
      },
    };
  },
  beforeRouteLeave(to, from, next) {
    if (to.name === 'achievementdetail') {
      this.$store.commit('setCache', 'TaskCollect');
    } else {
      this.$store.commit('delCache', 'TaskCollect');
    }
    next();
  },
  computed: {
    emptyStartDate() {
      return this.picker.startDateText.replace(/\-/g, '.');
    },
    emptyEndDate() {
      return this.picker.endDateText.replace(/\-/g, '.');
    },
    isShowEmptyData() {
      return this.myData.total === -1;
    },
    isShowListData() {
      return this.myData.total > 0;
    },
    isShowNoData() {
      return this.myData.total === 0;
    },
    customScrollHeight() {
      return `height:${window.innerHeight}px;`;
    },
  },
  mounted() {
    this.initData();
  },
  methods: {
    // 加载数据
    initData() {
      // 滚动条置顶
      window.scrollTo(0, 0);
      // 列表清空
      this.myData.list = [];
      // 加载数据
      this.$nextTick(() => {
        this.getDateBase(this.getMyData);
      });
    },
    // 通过接口获取数据
    getMyData() {
      Indicator.open();
      // 先设置禁止滚动加载数据
      this.myParam.startDate = `${this.picker.startDateText} 00:00:00`;
      this.myParam.endDate = `${this.picker.endDateText} 23:59:59`;
      GetUserTaskExpired(this.myParam)
        .then(res => {
          Indicator.close();
          SucceedHandle2(
            res.code,
            res.msg,
            () => {
              this.myData.sum = res.data.expiredSum;
              this.myData.list = res.data.userTaskExpired;
              this.myData.total = this.myData.list ? this.myData.list.length : 0;
            },
            (code, msg) => {
              msg && CusToast(msg);
            }
          );
        })
        .catch(err => {
          Indicator.close();
          this.myData.list = [];
          this.myData.total = -1;
          const msg = NotSucceedHandle(err.message);
          msg && CusToast(msg);
        });
    },
    // 交互后返回代理商列表
    getAgentListBox(nameOrMobile, callback = null) {
      Indicator.open();
      const agentFindType = 1;
      GetAgentListBox({ agentFindType, nameOrMobile })
        .then(res => {
          Indicator.close();
          SucceedHandle2(
            res.code,
            res.msg,
            () => {
              this.search.agent.list = res.rows;
              document.activeElement.blur();
              callback && callback();
            },
            (code, msg) => {
              msg && CusToast(msg);
            }
          );
        })
        .catch(err => {
          Indicator.close();
          const msg = NotSucceedHandle(err.message);
          msg && CusToast(msg);
        });
    },
    // 交互后返回日期查询条件
    getDateBase(callback = null) {
      DateBase({ interfaceName: '/app/Reward/GetUserTaskExpired' })
        .then(res => {
          SucceedHandle2(
            res.code,
            res.msg,
            () => {
              this.picker.startDateBase = res.data.startDate.split(' ')[0];
              this.picker.endDateBase = res.data.endDate.split(' ')[0];
              this.picker.startDateText = this.picker.startDateBase;
              this.picker.endDateText = this.picker.endDateBase;
              callback && callback();
            },
            (code, msg) => {
              msg && CusToast(msg);
            }
          );
        })
        .catch(err => {
          const msg = NotSucceedHandle(err.message);
          msg && CusToast(msg);
        });
    },
    // 跳页
    jumpDetail(count, date, type, agentid) {
      count && this.$router.push({ path: '/taskcollectdetail', query: { date, type, agentid } });
    },
    // 日期确定事件
    onDatePickerConfirm(val) {
      // 根据选择的日期类型判断
      switch (this.picker.dateType) {
        // 开始日期
        case 'startDate':
          // 如果开始日期选择了一个大于当前查询结束日期
          if (val > new Date(this.picker.endDateText)) {
            // 则将查询结束日期自动置为今天的日期
            this.picker.endDateText = formatDate(new Date());
          }
          this.picker.startDateText = formatDate(val);
          break;
        // 结束日期
        case 'endDate':
          this.picker.endDateText = formatDate(val);
          break;
      }
    },
    // 单击日期事件
    onSearchDateClick(val) {
      // 设置日期类型
      this.picker.dateType = val;
      // 根据选择的日期类型判断
      switch (val) {
        // 开始日期
        case 'startDate':
          // 日期框显示的最大日期：2000-01-01
          this.picker.startDate = new Date('2000-01-01');
          // 日期框显示的最小日期：今天
          this.picker.endDate = new Date();
          // 日期框显示的选中日期：默认查询开始日期
          this.picker.selectedDate = new Date(this.picker.startDateText);
          break;
        // 结束日期
        case 'endDate':
          // 日期框显示的最大日期：默认查询开始日期
          this.picker.startDate = new Date(this.picker.startDateText);
          // 日期框显示的最小日期：今天
          this.picker.endDate = new Date();
          // 日期框显示的选中日期：默认查询结束日期
          this.picker.selectedDate = new Date(this.picker.endDateText);
          break;
      }
      this.$refs.datePicker.open();
    },
    // 查询搜索取消事件
    onSearchCancelClick() {
      this.visible.search = false;
      this.clearSearchData();
    },
    // 查询搜索单击事件
    onSearchOkClick() {
      // 1.滚动条置顶
      window.scrollTo(0, 0);
      // 3.关闭查询窗口
      this.visible.search = false;
      // 4.重置列表数据
      this.myData.list = [];
      // 5.重置总数
      this.myData.total = -1;
      // 6. 加载数据
      this.getMyData();
    },
    // 返回按钮事件
    onGoBackClick() {
      window.location.href = 'protocol://android';
    },
    // 代理商列表选中商户名称事件
    onAgentListItemClick(item) {
      this.search.agent.selected = `${item.name} ${item.mobile}`;
      this.myParam.productAgentId = item.productAgentId;
      this.search.agent.empty = false;
      this.visible.agent = false;
    },
    // 设置注册数/达标数的样式
    setBlueClass(val) {
      return val !== '0' ? 'link' : '';
    },
    // 筛选窗口代理商类型点击事件
    onAgentTypeClick(item) {
      this.myParam.agentFindType = item.value;
      item.value !== 2 && (this.myParam.productAgentId = '');
    },
    // 筛选窗口代理商名称点击事件
    onAgentNameClick() {
      this.getAgentListBox('', () => {
        this.visible.agent = true;
        this.search.agent.key = '';
      });
    },
    // 清空筛选框中代理商名称的事件
    onAgentNameClearClick() {
      this.search.agent.selected = '';
      this.myParam.productAgentId = '';
      this.search.agent.empty = true;
    },
    // 代理商名称列表商户名称查询事件
    onAgentSearchEnter() {
      this.getAgentListBox(this.search.agent.key);
    },
    // 置空所有筛选窗口数据
    clearSearchData() {
      this.search.agent.empty = true;
      this.picker.startDateText = this.picker.startDateBase;
      this.picker.endDateText = this.picker.endDateBase;
    },
  },
  filters: {
    noYearDate(val) {
      return val.substring(5);
    },
  },
};
</script>
